import { DECLINING_TAG, GROWING_TAG } from "./signalDirectionTags";

export type SignalDirectionDisplayTag = typeof GROWING_TAG | typeof DECLINING_TAG;

export type GrowingDecliningDirectionToTagMap<TDirection extends string> = Record<
    TDirection,
    SignalDirectionDisplayTag
>;

type GrowingDecliningDirections<TDirection extends string> = {
    readonly grew: TDirection;
    readonly declined: TDirection;
};

export function createGrowingDecliningDirectionToTagMap<TDirection extends string>(
    directions: GrowingDecliningDirections<TDirection>,
): GrowingDecliningDirectionToTagMap<TDirection> {
    return {
        [directions.grew]: GROWING_TAG,
        [directions.declined]: DECLINING_TAG,
    } as GrowingDecliningDirectionToTagMap<TDirection>;
}
